import { Grid, Stack } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { Fragment } from 'react';
import { z } from 'zod';

import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { AdministrationBody } from '@/components/management/layout/AdministrationBody';
import { AdministrationHeader } from '@/components/management/layout/AdministrationHeader';
import { PasswordResetRequestForm } from '@/components/public/PasswordResetRequestForm';
import { backendApiPasswordResetInitializeMutation } from '@/modules/api/backend/@tanstack/react-query.gen';
import { useSnackbarStore } from '@/stores/useSnackbarStore';

const defaultSearchValues = {
  initialized: false,
};

const zValidateSearch = z.object({
  initialized: z.boolean().default(defaultSearchValues.initialized).catch(defaultSearchValues.initialized),
});

export const Route = createFileRoute('/_public/_authentication/password-reset/')({
  validateSearch: zValidateSearch,
  search: {
    middlewares: [stripSearchParams(defaultSearchValues)],
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();

  const { openSnackbar } = useSnackbarStore((state) => state.actions);

  const { mutateAsync } = useMutation({
    ...backendApiPasswordResetInitializeMutation(),
    meta: { invalidateQueries: false },
    onSuccess: () => {
      openSnackbar({
        color: 'success',
        message: 'Ein Link zum Zurücksetzen des Passworts wurde an Ihre E-Mail-Adresse gesendet!',
      });
      navigate({ to: '/login' });
    },
    onError: () => {
      openSnackbar({
        color: 'error',
        message: 'Fehler beim Senden des Zurücksetzungslinks.',
      });
    },
  });

  return (
    <Fragment>
      <Header />
      <AdministrationHeader label="Passwort zurücksetzen" />
      <AdministrationBody>
        <Grid
          container
          direction={{ sm: 'column', lg: 'row' }}
          spacing={{ sm: 2, lg: 13 }}
          sx={{ pt: { xs: 8, lg: 0 } }}
        >
          <Grid size={{ sm: 12, lg: 5.5 }} sx={{ mx: 'auto' }}>
            <PasswordResetRequestForm
              onSubmit={async (value) => {
                await mutateAsync({ body: value });
                await navigate({ search: { initialized: true } });
              }}
            />
          </Grid>
        </Grid>
      </AdministrationBody>
      <Stack
        component="footer"
        sx={{
          display: { xs: 'none', lg: 'flex' },
          position: 'fixed',
          bottom: 0,
          width: '100%',
        }}
      >
        <Footer />
      </Stack>
    </Fragment>
  );
}
